<div class="flex justify-content-center w-full">
    <h1>{{ pageMessage }}</h1>
</div>